import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addReviewsFailure,
  //
  addReviewsSuccess,
  deleteReviewsFailure,
  //
  deleteReviewsSuccess,
  editReviewsFailure,
  //
  editReviewsSuccess,
  fetchReviews as fetchReviewsAction,
  fetchReviewsFailure,
  fetchReviewsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  //
  fetchUploads,
  fetchUploadsSuccess,
  fetchUploadsFailure,
  //
  addReviewCardSuccess,
  addReviewCardFailure,
  //
  editReviewCardSuccess,
  editReviewCardFailure,
  //
  getCardDataSuccess,
  getCardDataFailure,
} from "./actions";
import {
  ADD_REVIEWS,
  DELETE_REVIEWS,
  EDIT_REVIEWS,
  FETCH_REVIEWS,
  GET_VIEW_DATA,
  FETCH_UPLOADS,
  ADD_REVIEW_CARD,
  EDIT_REVIEW_CARD,
  GET_CARD_DATA,
} from "./constants";

export function* fetchReviewsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/review?${query}`);
    yield put(fetchReviewsSuccess(data));
  } catch (e) {
    yield put(fetchReviewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching reviews!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/review/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addReviewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/review/add`, payload.data);
    if (data) {
      yield put(successAlert("Review added successfully!"));
      yield put(addReviewsSuccess());
      if (payload?.history) {
        payload.history.push("/d/reviews");
      }
    }
  } catch (e) {
    yield put(addReviewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editReviewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/review/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Review updated successfully!"));
      yield put(editReviewsSuccess());
      yield put(getViewDataAction(payload.data.id));
    }
  } catch (e) {
    yield put(editReviewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteReviewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/review/${payload}`);
    if (data) {
      yield put(successAlert("Review deleted successfully!"));
      yield put(deleteReviewsSuccess());
      yield put(fetchReviewsAction());
    }
  } catch (e) {
    yield put(deleteReviewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchUploadsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/index-review-card?${query}`
    );
    yield put(fetchUploadsSuccess(data));
  } catch (e) {
    yield put(fetchUploadsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* addReviewCardSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/store-review-card`,
      payload.data
    );
    typeof onSuccess == "function" && onSuccess();

    if (data) {
      yield put(successAlert("Review card uploaded successfully!"));
      yield put(addReviewCardSuccess());
      yield put(
        fetchUploads({
          page: 1,
          location_id: payload?.location_id ?? "",
          limit: 10,
        })
      );
    }
  } catch (e) {
    yield put(addReviewCardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editReviewCardSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/update-review-card/edit/${payload.id}`,
      payload.data
    );

    if (data) {
      yield put(successAlert("Data updated successfully!"));
      yield put(editReviewCardSuccess());
      typeof onSuccess == "function" && onSuccess();
    }
  } catch (e) {
    yield put(editReviewCardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getCardDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/show-review-card/${payload}`
    );
    yield put(getCardDataSuccess(data));
  } catch (e) {
    yield put(getCardDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* fetchReviewsFlow() {
  yield takeEvery(FETCH_REVIEWS, fetchReviewsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addReviewsFlow() {
  yield takeEvery(ADD_REVIEWS, addReviewsSaga);
}
export function* editReviewsFlow() {
  yield takeEvery(EDIT_REVIEWS, editReviewsSaga);
}
export function* deleteReviewsFlow() {
  yield takeEvery(DELETE_REVIEWS, deleteReviewsSaga);
}
export function* fetchUploadsFlow() {
  yield takeEvery(FETCH_UPLOADS, fetchUploadsSaga);
}
export function* addReviewCardFlow() {
  yield takeEvery(ADD_REVIEW_CARD, addReviewCardSaga);
}
export function* editReviewCardFlow() {
  yield takeEvery(EDIT_REVIEW_CARD, editReviewCardSaga);
}
export function* getCardDataFlow() {
  yield takeEvery(GET_CARD_DATA, getCardDataSaga);
}

export default function* ReviewsSaga() {
  yield all([
    fetchReviewsFlow(),
    addReviewsFlow(),
    editReviewsFlow(),
    deleteReviewsFlow(),
    getViewDataFlow(),
    fetchUploadsFlow(),
    addReviewCardFlow(),
    editReviewCardFlow(),
    getCardDataFlow(),
  ]);
}
